import { useEffect } from 'react'
import { UpdatedCalcs } from 'admin/UpdatedCalcs'
import { useDashboardCalculations } from './useDashboardCalculations'

export function useAutoUpdateScores({
  intakeState,
  updateIntakeStateAndSubmit,
  updateIntakeStateAtKey,
  assets,
  liabilities,
  deductions,
}) {
  const { valueOfAssets, valueOfInvestableAssets } = UpdatedCalcs({
    assets,
    liabilities,
  })
  const {
    normalizedGrossGap,
    adjustedNetPayRetirement,
    adjustedWorkingNetTakeHome,
  } = useDashboardCalculations(deductions, liabilities)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const parcoReadinessScore4Percent = isNaN(
        Math.max(
          0,
          (() => {
            const taxRate = intakeState?.taxRate || 20
            const numerator =
              adjustedNetPayRetirement * 12 +
              valueOfAssets * 0.75 * 0.04 * (1 - taxRate / 100)
            const denominator = adjustedWorkingNetTakeHome * 12
            const ratio = numerator / denominator

            if (ratio === Infinity) return 0
            return Math.min(ratio, 0.95)
          })()
        )
      )
        ? 0
        : Math.max(
            0,
            (() => {
              const taxRate = intakeState?.taxRate || 20
              const numerator =
                adjustedNetPayRetirement * 12 +
                valueOfAssets * 0.75 * 0.04 * (1 - taxRate / 100)
              const denominator = adjustedWorkingNetTakeHome * 12
              const ratio = numerator / denominator

              if (ratio === Infinity) return 0
              return Math.min(ratio, 0.95)
            })()
          )

      const calculatedGap = isNaN(normalizedGrossGap * 12)
        ? 0
        : normalizedGrossGap * 12

      const investableAssets = isNaN(valueOfInvestableAssets)
        ? 0
        : valueOfInvestableAssets

      const shouldUpdateParco =
        intakeState.parcoScore == null ||
        Math.abs(intakeState.parcoScore - parcoReadinessScore4Percent) > 0.01

      const shouldUpdateGap =
        intakeState.retirementIncomeGap == null ||
        Math.abs(intakeState.retirementIncomeGap - calculatedGap) > 10

      const shouldUpdateInvestable =
        intakeState.totalInvestableAssets == null ||
        Math.abs(intakeState.totalInvestableAssets - investableAssets) > 10

      if (shouldUpdateParco || shouldUpdateGap || shouldUpdateInvestable) {
        // console.log('updating scores...')
        updateIntakeStateAndSubmit(() =>
          updateIntakeStateAtKey({
            parcoScore: parcoReadinessScore4Percent,
            retirementIncomeGap: calculatedGap,
            totalInvestableAssets: investableAssets,
            firstName: intakeState?.firstName
              ? intakeState?.firstName.trim()
              : '',
            lastName: intakeState?.lastName ? intakeState?.lastName.trim() : '',
            fullName: intakeState?.firstName
              ? intakeState?.firstName.trim() + ' ' + intakeState?.lastName
              : '',
          })
        )()
      }
    }, 3000)

    return () => clearTimeout(timeoutId)
  }, [
    intakeState,
    assets,
    liabilities,
    deductions,
    updateIntakeStateAndSubmit,
    updateIntakeStateAtKey,
  ])
}
